<div class="fs-container">
  <fs-axon-managed-permission-message
    [isExternallyManaged]="group.isExternallyManaged"
    [externalRef]="group.externalRef"
    [canEditPermissions]="canEditPermissions"
    [canEditMembers]="canEditMembers"
    [groupName]="group.name"
  >
  </fs-axon-managed-permission-message>

  <div class="fs-mt-4">
    <div class="fs-row">
      <div class="fs-col-12">
        <mat-form-field appearance="outline" class="header-input">
          <mat-label>{{ 'users.policyGroups.manageGroupNameLabel' | t }}</mat-label>
          <input
            matInput
            [disabled]="group.isExternallyManaged || !canChange"
            [placeholder]="'users.policyGroups.manageGroupNameLabel' | t"
            required
            [(ngModel)]="group.name"
          />
        </mat-form-field>
      </div>
    </div>
    <div class="fs-row">
      <div class="fs-col-6">
        <div class="policies section">
          <h4>{{ 'common.permissions' | t }}</h4>
          <mat-progress-bar
            class="fs-mb-2"
            *ngIf="isLoading"
            mode="indeterminate"
          ></mat-progress-bar>
          <div class="accordion-container">
            <sn-empty-state
              *ngIf="group.policies?.length < 1"
              icon="cancel_presentation"
              [title]="'users.policyGroups.managePoliciesNoPolicies' | t"
            >
              <button
                *ngIf="canEditPermissions"
                mat-button
                class="add-policy-button"
                (click)="addPolicy()"
              >
                {{ 'users.policyGroups.managePoliciesAddPolicy' | t }}
              </button>
            </sn-empty-state>
            <mat-accordion>
              <mat-expansion-panel
                [class.system]="policy.isSystemManaged"
                *ngFor="let policy of group.policies; let i = index"
              >
                <mat-expansion-panel-header>
                  <mat-panel-title
                    ><div class="policy-name">{{ policy.name }}</div></mat-panel-title
                  >
                  <mat-panel-description>
                    <span
                      [class.denyPolicy]="policy.isDenyPolicy"
                      [class.allowPolicy]="!policy.isDenyPolicy"
                      >{{ policy.isDenyPolicy ? ('common.deny' | t) : ('common.allow' | t) }}</span
                    >
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                  <div *ngIf="policy.type === 'camera'">
                    <button
                      mat-button
                      *ngIf="policy.cameras?.length > 0 && canEditPermissions"
                      class="edit-policy"
                      color="accent"
                      (click)="editPolicy(policy)"
                    >
                      {{ 'users.policyGroups.managePoliciesEditPolicy' | t }}
                    </button>
                    <p class="permissions">
                      <strong>{{ 'common.permissions' | t }}:</strong> {{ policy.permissions }}
                    </p>
                    <h5>{{ 'common.cameras' | t }}:</h5>
                    <fs-cameras-resource
                      [resources]="policy.resources"
                      [cameras]="policy.cameras"
                      (loadedCameras)="set(policy, 'cameras', $event)"
                    ></fs-cameras-resource>
                  </div>
                  <div *ngIf="policy.type === 'location'">
                    <button
                      *ngIf="canEditPermissions"
                      mat-button
                      class="edit-policy"
                      color="accent"
                      (click)="editPolicy(policy)"
                    >
                      {{ 'users.policyGroups.managePoliciesEditPolicy' | t }}
                    </button>
                    <p class="permissions">
                      <strong>{{ 'common.permissions' | t }}:</strong> {{ policy.permissions }}
                    </p>
                    <h5>{{ 'common.locations' | t }}:</h5>
                    <fs-locations-resource
                      [resources]="policy.resources"
                      [locations]="policy.locations"
                      (loadedLocations)="set(policy, 'locations', $event)"
                    ></fs-locations-resource>
                  </div>
                  <div *ngIf="policy.type === 'Camera Tag'">
                    <button
                      *ngIf="canEditPermissions"
                      mat-button
                      class="edit-policy"
                      color="accent"
                      (click)="editPolicy(policy)"
                    >
                      {{ 'users.policyGroups.managePoliciesEditPolicy' | t }}
                    </button>
                    <p class="permissions">
                      <strong>{{ 'common.permissions' | t }}:</strong> {{ policy.permissions }}
                    </p>
                    <h5>{{ 'common.tags' | t }}:</h5>
                    <fs-tags-resource
                      [resources]="policy.resources"
                      [tags]="policy.tags"
                    ></fs-tags-resource>
                  </div>
                  <div *ngIf="policy.type === 'Location Tag'">
                    <button
                      *ngIf="canEditPermissions"
                      mat-button
                      class="edit-policy"
                      color="accent"
                      (click)="editPolicy(policy)"
                    >
                      {{ 'users.policyGroups.managePoliciesEditPolicy' | t }}
                    </button>
                    <p class="permissions">
                      <strong>{{ 'common.permissions' | t }}:</strong> {{ policy.permissions }}
                    </p>
                    <h5>{{ 'common.tags' | t }}:</h5>
                    <fs-tags-resource
                      [resources]="policy.resources"
                      [tags]="policy.tags"
                    ></fs-tags-resource>
                  </div>
                  <div *ngIf="policy.type === 'permission'">
                    <p class="permissions">
                      <strong>{{ 'common.permissions' | t }}:</strong> {{ policy.permissions }}
                    </p>
                  </div>
                  <button
                    mat-button
                    *ngIf="canEditPermissions"
                    class="delete-policy"
                    color="danger"
                    (click)="removePolicy(i)"
                  >
                    {{ 'users.policyGroups.managePoliciesRemovePolicy' | t }}
                  </button>
                </ng-template>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
          <div class="fs-row fs-actions" *ngIf="canEditPermissions">
            <button mat-button (click)="inheritPolicies()">{{ 'users.policyGroups.addPermissions' | t }}</button>
            <button mat-button class="add-policy" (click)="addPolicy()">{{ 'users.policyGroups.managePoliciesAddPolicy' | t }}</button>
            <button mat-button color="success" (click)="save()">
              <sn-icon fontSet="fal" fontIcon="fa-save"></sn-icon>
              {{ 'common.save' | t }}
            </button>
          </div>
        </div>
      </div>
      <div class="fs-col-6">
        <div class="section">
          <h4 #userHeading id="manage-policy-users-header">{{ 'common.users' | t }}</h4>
          <fs-policy-users
            [attr.aria-labelledby]="userHeading.id"
            role="region"
            *ngIf="group.id"
            [id]="group.id"
            [canChange]="canEditMembers"
          ></fs-policy-users>
        </div>
      </div>
    </div>
  </div>
</div>
